import * as React from 'react';

// COMPONENTS
import Button from './Button';
import StatusIcon from './StatusIcon';
import GlobalModal from './GlobalModal';
import AddDocumentModal from '../pages/StaffProfile/Modals/AddDocumentModal';
import CitedDocumentModal from '../pages/StaffProfile/Modals/CitedDocumentModal';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchDocument } from '../api/models';

interface PastProfileCertificationsTypes {
	certifications?: Array<StaffFetchDocument>;
	defaultMaxItems?: number;
	referenceChecks?: Array<StaffFetchDocument>;
	staffId?: string;
	canUpdate?: boolean;
	getStaffProfileData: () => Promise<void>;
	isYou: boolean | undefined;
}

const PastProfileCertifications: React.FC<PastProfileCertificationsTypes> = ({
	certifications,
	defaultMaxItems,
	referenceChecks,
	staffId,
	canUpdate,
	isYou,
	getStaffProfileData
}) => {
	// Max Certifications Item that user can view before clicking show more
	const [maxCertificationsItem, setMaxCertificationsItem] = React.useState<number>(defaultMaxItems || 5);

	// Hide and Show Modals
	const [showAddDocumentModal, setShowAddDocumentModal] = React.useState<boolean>(false);

	const [showCitedDocumentModal, setShowCitedDocumentModal] = React.useState<boolean>(false);

	// State to control Form ID and Form Modal
	const [currentFormID, setCurrentFormId] = React.useState<string>('');

	const [currentFormModal, setCurrentFormModal] = React.useState<string>('');

	// Join Reference Checks and Certifications
	const certificationJoin = [...(referenceChecks || []), ...(certifications || [])];

	// Function to decide which modal to show based on the item clicked
	const viewCertification = (item: any) => {
		if (item.displayName === 'Reference checks') {
			setCurrentFormModal(item.displayName || '');

			setCurrentFormId(item.id || '');

			setShowAddDocumentModal(true);
		} else {
			setShowCitedDocumentModal(true);

			setCurrentFormModal(item.displayName || '');

			setCurrentFormId(item.id || '');
		}
	};

	return (
		<>
			{certificationJoin && certificationJoin.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Documents</h2>
					</div>

					{certificationJoin.slice(0, maxCertificationsItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<StatusIcon statusType={item.status || 'Error'} />
									</div>

									<div className="col-md-auto col-lg-9 full-width">
										<div className="row detail-info">
											<div className="col-lg-4 detail-name">
												{item.displayName}
												{item.title && ` - ${item.title}`}
											</div>

											<div className="col-lg-8 detail-status">
												<span className={`label ${item.status?.toLowerCase()}`}>{item.statusLabel}</span>
											</div>
										</div>
									</div>

									<div className="col-auto pdr-0 link-group">
										<Button
											className="btn-text"
											type="button"
											onClick={() => {
												viewCertification(item);
											}}
										>
											View
										</Button>
									</div>
								</div>
							</div>
						);
					})}

					{certificationJoin && certificationJoin.length > 0 && maxCertificationsItem < certificationJoin.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxCertificationsItem(certificationJoin.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {certificationJoin.length - maxCertificationsItem} more
						</Button>
					)}
				</section>
			)}

			<GlobalModal titleText={currentFormModal} isOpen={showAddDocumentModal} setIsOpen={setShowAddDocumentModal}>
				<AddDocumentModal
					formType={currentFormModal}
					staffId={staffId}
					getStaffProfileData={getStaffProfileData}
					currentFormID={currentFormID}
					disabledForm
				/>
			</GlobalModal>

			<GlobalModal isOpen={showCitedDocumentModal} titleText={currentFormModal} setIsOpen={setShowCitedDocumentModal}>
				<CitedDocumentModal
					update={getStaffProfileData}
					canUpdate={canUpdate}
					isYou={isYou}
					setTitle={setCurrentFormModal}
					formId={currentFormID}
					profileId={staffId}
				/>
			</GlobalModal>
		</>
	);
};

export default PastProfileCertifications;
